<template>
    <v-dialog
            v-model="isDialog"
            persistent
            style="z-index: 600;"
            max-width="450"
            :light="true"
    >
        <v-card v-if="isDialog">
            <v-card-title class="headline">SMS Bestätigungscode</v-card-title>

            <!--            v-on:submit.prevent-->
            <!--            form is required to react on virtual keyboard done event-->
            <v-card-text>
                <!--                                        <label>-->
                <!--                                            <input style="color: red" type="text" v-model="search">-->
                <!--                                        </label>-->
                <!--                    :keyup.13="doSearch"-->
                <div class="bigger-input">
                    <div>Bitte gib den Bestätigungscode ein, den du gerade per SMS
                        erhalten haben:
                    </div>
                    <div style="height: 15px"></div>

                    <v-text-field
                            v-model="sms"
                            label="SMS"
                            ref="smsInput"
                            placeholder="Bestätigungscode"
                            @keyup.native.enter="doProcess"
                            :autofocus="true"
                            hide-details
                    ></v-text-field>
                </div>
            </v-card-text>


            <v-card-actions>
                <v-spacer></v-spacer>

                <!--                    <button type="submit"-->
                <!--                            style="padding: 0 16px;font-size: 14px;font-weight: 500;"-->
                <!--                            @click.prevent="doSearch">SUCHEN-->
                <!--                    </button>-->

                <div class="mr-4 underline">
                    <span @click.passive.stop="cancleDialog" class="pointer">Abbrechen</span>
                </div>

                <v-btn
                        class="btn-df okBtn"
                        text
                        @click.native.passive="doProcess"
                >
                    Bestätigen
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
    // import * as util from '../vendor/util'

    export default {
        props: {
            dialog: Boolean,
        },
        data() {
            return {
                isDialog: false,
                sms: ''
            }
        },
        // beforeCreate(){
        //     util.enableNoScroll(true)
        // },
        // beforeDestroy(){
        //     util.enableNoScroll(false)
        // },
        watch: {
            dialog(newValue) {
                this.isDialog = newValue;
                if (newValue) {
                    //init
                    // this.search = '' + this.searchInput;
                }
            },
            isDialog(newValue) {
                if (!newValue) {
                    // this.ready = false;
                    this.$emit('close');
                }
            }
        },

        methods: {
            doProcess(event) {
                this.$refs.smsInput.blur();
                // if (this.sms.length > 1) {
                this.isDialog = false;
                this.$emit('verifySmsCode', this.sms);//yes
                // } else {
                //     this.isDialog = false;
                // }
            },
            cancleDialog() {
                this.isDialog = false;
                this.$emit('cancleDialog');//yes
            }
        }
    }
</script>

<style lang="scss" scoped>
    /*.vvd{*/
    /*    >>> .v-dialog{*/
    /*        position: absolute;*/
    /*    }*/
    /*}*/
</style>